export const HIDE_SHARE_PATHS = [
    '/news-and-insights/announcements/permira-offer-for-jtc-plc',
];

export const isHideSharePath = currentUrl => {
    if (!currentUrl) {
        return false;
    }
    const currentPath = new URL(currentUrl).pathname.replace(/\/$/, '');
    return HIDE_SHARE_PATHS.includes(currentPath);
};
